import { Component, OnInit, OnDestroy, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

/* Services */

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProdutoService } from '../../core/services/produtos/produto.service';
import { PromocoesService, PromocaoListFilters } from '../../core/services/produtos/promocoes.service';
import { ConfiguracaoService } from '../../core/services/configuracoes/configuracao.service';
import { estaBloqueado } from '../../core/permissoes/permissoes';

/* Models */

import { Produto } from '../../core/models/produtos/produto';
import { AtualizarCustosResultDto, CustoItemDto, ItemResultadoDto } from '../../core/models/produtos/atualizar-custos-resultado';
import { ProdutoCampanha } from '../../core/models/produtos/produto-campanha';
import { ProdutoCampanhaItens } from '../../core/models/produtos/produto-campanha-itens';
import { ProdutoTabelaEspecialItens } from '../../core/models/produtos/produto-tabela-especial-itens';
import { ProdutoTabelaEspecial } from '../../core/models/produtos/produto-tabela-especial';
import { PromoLog } from '../../core/models/produtos/promo-log';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { ProdutoFoto } from '../../core/models/produtos/produto-foto';

@Component({
    selector: 'app-produtos',
    templateUrl: './produtos.component.html',
    styleUrls: ['./produtos.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class ProdutosComponent implements OnInit, OnDestroy {
  /* Carregamento */

  carregando: boolean = false;
  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  is_financeiro: boolean = (localStorage.getItem("is_financeiro") == "true");

  /* Abas */

  tabSelecionada: string = "produtos";

  /* Filtro (Produtos) */

  formFiltroProduto: UntypedFormGroup;

  filtroProdutos: any[] = [
    { texto: "Código", valor: "0" },
    { texto: "Descrição", valor: "1" },
    { texto: "Marca", valor: "2" }
  ];

  enviadoProduto: boolean = false;

  filtrandoProduto: boolean = false;

  /* Produtos */

  produtos: Produto[] = [];
  produtosOriginal: Produto[] = [];
  configuracao: Configuracao = null;
  atualizandoProdutoTrId: number = 0;

  /* Produtos (Paginação) */

  produtosPagina: Produto[] = [];
  produtosPage: number = 1;
  produtosPageSize: number = 30;
  produtosPageSizes: number[] = [30, 50, 100];

  /* Produto (Foto na lista) */

  @ViewChild("arquivoFotoLista") arquivoFotoLista: ElementRef;

  produtoFotoCache: { [id: number]: string } = {};
  produtoFotoEnviando: number = 0;
  private produtoFotoBuscando = new Set<number>();
  private produtoUploadAtual: Produto = null;

  /* Produto (Campanha Itens) */

  produtosCampanhaItens: ProdutoCampanhaItens[] = [];

  /* Produto (Campanha) */

  produtosCampanha: ProdutoCampanha[] = [];

  produtoCampanhaExpandido: number = -1;

  campPage: number = 1;
  campPageSize: number = 20;

  get campTotal(): number { return this.produtosCampanha.length; }
  get campTotalPaginas(): number { return Math.ceil(this.campTotal / this.campPageSize); }
  get produtosCampanhaPaginados(): ProdutoCampanha[] {
    const start = (this.campPage - 1) * this.campPageSize;
    return this.produtosCampanha.slice(start, start + this.campPageSize);
  }

  /* Produto (Tabela Especial (Itens)) */

  produtosTabelaEspecialItens: ProdutoTabelaEspecialItens[] = [];

  /* Produto (Tabela Especial) */

  produtosTabelaEspecial: ProdutoTabelaEspecial[] = [];

  produtoTabelaEspecialExpandido: number = -1;

  /* Promoções (busca paginada) */

  promoFiltros: PromocaoListFilters = { descricao: '', ativo: null, tabelaEspecial: false };
  promoPage: number = 1;
  promoPageSize: number = 20;
  promoTotal: number = 0;
  promoItems: ProdutoTabelaEspecial[] = [];
  promoCarregando: boolean = false;
  promoBuscaRealizada: boolean = false;

  private promoBusca$ = new Subject<void>();
  private promoDestroy$ = new Subject<void>();

  /* Promo Log */

  @ViewChild('modalPromoLog') private modalPromoLogTemplate: TemplateRef<any>;
  promoLogModal: PromoLog[] = [];
  promoLogModalCarregando: boolean = false;
  promoLogModalNome: string = '';

  /* Custo */

  custoArquivo: File = null;
  custoLinhas: CustoItemDto[] = [];
  custoAtualizarPromocoes: boolean = true;
  custoEnviando: boolean = false;
  custoResultado: AtualizarCustosResultDto = null;
  custoErroUpload: string = null;
  custoFiltroStatus: string = '';

  /* Modelo Custos - Filtros */

  modeloCustosDescricao: string = '';

  modeloCustosTiposFiltro: { campo: string, label: string }[] = [
    { campo: 'grupo_estoque', label: 'Marcas' },
    { campo: 'categoria', label: 'Categoria' },
    { campo: 'subgrupo_estoque', label: 'Subgrupo 1' },
    { campo: 'subgrupo_estoque2', label: 'Subgrupo 2' },
    { campo: 'subgrupo_estoque3', label: 'Subgrupo 3' }
  ];

  modeloCustosFiltroSelecionado: string = 'grupo_estoque';
  modeloCustosValorSelecionado: string = '';
  modeloCustosValoresDisponiveis: string[] = [];
  modeloCustosFiltrosAplicados: { campo: string, label: string, valor: string }[] = [];

  get custoItensFiltrados(): ItemResultadoDto[] {
    if (!this.custoResultado || !this.custoResultado.itens) return [];
    if (!this.custoFiltroStatus) return this.custoResultado.itens;
    return this.custoResultado.itens.filter(i =>
      (i.status || '').toUpperCase() === this.custoFiltroStatus
    );
  }

  get custoItensNaoEncontrados(): ItemResultadoDto[] {
    if (!this.custoResultado || !this.custoResultado.itens) return [];
    return this.custoResultado.itens.filter(i =>
      (i.status || '').toUpperCase() === 'NOT_FOUND'
    );
  }

  get custoItensComErro(): ItemResultadoDto[] {
    if (!this.custoResultado || !this.custoResultado.itens) return [];
    return this.custoResultado.itens.filter(i => {
      const s = (i.status || '').toUpperCase();
      return s !== 'UPDATED' && s !== 'NOT_FOUND';
    });
  }

  get custoItensComProblema(): ItemResultadoDto[] {
    if (!this.custoResultado || !this.custoResultado.itens) return [];
    return this.custoResultado.itens.filter(i =>
      (i.status || '').toUpperCase() !== 'UPDATED'
    );
  }

  bloqueado(chave: string): boolean {
    return estaBloqueado(chave);
  }

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private produtoService: ProdutoService,
    private promocoesService: PromocoesService,
    private configuracaoService: ConfiguracaoService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    /* Filtro (Produtos) */

    this.formFiltroProduto = this.formBuilder.group({
      filtro: ["1"],
      codigo: ["", Validators.required],
      descricao: ["", Validators.required],
      marca: ["", Validators.required]
    });

    this.organizarFiltroProduto();

    this.configuracaoService.getByGuidClienteNapis().subscribe(
      configuracao => this.configuracao = configuracao,
      error => { console.log("Erro: " + error) }
    );

    this.carregarDados(true);

    /* Promoções — stream reativo paginado */

    this.promoBusca$.pipe(
      switchMap(() => {
        this.promoCarregando = true;
        return this.promocoesService.searchPaged(this.promoFiltros, this.promoPage - 1, this.promoPageSize);
      }),
      takeUntil(this.promoDestroy$)
    ).subscribe(result => {
      this.promoCarregando = false;
      this.promoBuscaRealizada = true;
      this.promoItems = result.items;
      this.promoTotal = result.total || 0;
    });

    this.promoBusca$.next();
  }

  ngOnDestroy() {
    this.promoDestroy$.next();
    this.promoDestroy$.complete();
  }

  get fp() {
    return this.formFiltroProduto.controls;
  }

  /* Produtos (Paginação) */

  get produtosTotalPaginas(): number {
    return Math.max(1, Math.ceil(this.produtos.length / this.produtosPageSize));
  }

  private atualizarPaginaProdutos() {
    if (this.produtosPage > this.produtosTotalPaginas) {
      this.produtosPage = this.produtosTotalPaginas;
    }

    if (this.produtosPage < 1) {
      this.produtosPage = 1;
    }

    let inicio = (this.produtosPage - 1) * this.produtosPageSize;

    this.produtosPagina = this.produtos.slice(inicio, inicio + this.produtosPageSize);

    this.buscarFotosProdutosVisiveis();
  }

  produtosMudarPagina(pagina: number) {
    this.produtosPage = pagina;

    this.atualizarPaginaProdutos();
  }

  produtosMudarPageSize(size: number) {
    this.produtosPageSize = size;
    this.produtosPage = 1;

    this.atualizarPaginaProdutos();
  }

  /* Produto (Foto na lista) */

  private buscarFotosProdutosVisiveis() {
    if (this.produtosPagina.length == 0) {
      return;
    }

    let idsParaBuscar: number[] = this.produtosPagina
      .map(produto => produto.id)
      .filter(id => this.produtoFotoCache[id] === undefined && !this.produtoFotoBuscando.has(id));

    if (idsParaBuscar.length == 0) {
      return;
    }

    idsParaBuscar.forEach(id => this.produtoFotoBuscando.add(id));

    this.produtoService.getProdutoFotosByIds(idsParaBuscar).subscribe(
      fotos => {
        idsParaBuscar.forEach(id => {
          let foto = fotos.find(foto => foto.id_produto == id);

          this.produtoFotoCache[id] = foto != null ? ("data:image/png;base64," + foto.imagem) : null;
        });
      },
      error => { console.log("Erro: " + error) },
      () => {
        idsParaBuscar.forEach(id => this.produtoFotoBuscando.delete(id));
      }
    );
  }

  abrirUploadFotoProduto(produto: Produto, event: Event) {
    event.stopPropagation();

    if (this.produtoFotoEnviando > 0) {
      return;
    }

    this.produtoUploadAtual = produto;

    this.arquivoFotoLista.nativeElement.value = "";
    this.arquivoFotoLista.nativeElement.click();
  }

  onArquivoFotoListaSelecionado(evento: any) {
    if (this.produtoUploadAtual == null || evento.target.files.length == 0) {
      return;
    }

    const arquivo = evento.target.files[0];
    const produto = this.produtoUploadAtual;

    if (arquivo.type != "image/png") {
      this.toastr.error("", "Arquivo inválido! Selecione um PNG.");

      return;
    }

    if ((arquivo.size / (1024 * 1024)) > 0.16) {
      /* 160KB */

      this.toastr.error("", "Arquivo selecionado acima de 160KB!");

      return;
    }

    this.produtoFotoEnviando = produto.id;

    const reader = new FileReader();

    reader.onload = (imagem: any) => {
      let base64: string = btoa(imagem.target.result);

      let produtoFoto = new ProdutoFoto();

      produtoFoto.id_produto = produto.id;
      produtoFoto.dt_ultima_atualizacao = new Date();
      produtoFoto.imagem = base64;
      produtoFoto.padrao = false;

      this.produtoService.addProdutoFoto(produtoFoto).subscribe(
        novoId => {
          if (novoId) {
            this.produtoService.updatePadraoById(novoId, produto.id).subscribe(
              () => { },
              error => { console.log("Erro: " + error) },
              () => {
                this.produtoFotoCache[produto.id] = "data:image/png;base64," + base64;
                this.produtoFotoEnviando = 0;

                this.toastr.success("", "Foto adicionada com sucesso!");
              }
            );
          } else {
            this.produtoFotoEnviando = 0;
          }
        },
        error => {
          console.log("Erro: " + error);

          this.produtoFotoEnviando = 0;
        }
      );
    };

    reader.readAsBinaryString(arquivo);
  }

  /* Abas */

  alterarAbas(evento: any) {
    this.tabSelecionada = evento.nextId;
    if (evento.nextId === 'promocoes') {
      this.promoFiltros = { descricao: '', ativo: null, tabelaEspecial: false };
      this.promoPage = 1;
      this.promoItems = [];
      this.promoBuscaRealizada = false;
      this.promoBusca$.next();
    } else if (evento.nextId === 'tabela-especial') {
      this.promoFiltros = { descricao: '', ativo: null, tabelaEspecial: true };
      this.promoPage = 1;
      this.promoItems = [];
      this.promoBuscaRealizada = false;
      this.promoBusca$.next();
    }
  }

  abrirLogPromo(promo_id: number, nome: string) {
    this.promoLogModalNome = nome;
    this.promoLogModalCarregando = true;
    this.promoLogModal = [];
    this.modalService.open(this.modalPromoLogTemplate, { size: 'lg', backdrop: 'static' });
    this.promocoesService.getPromoLogById(promo_id).subscribe(
      logs => this.promoLogModal = logs || [],
      error => { console.log("Erro: " + error); },
      () => { this.promoLogModalCarregando = false; }
    );
  }

  /* Ações */

  alterarProduto(id: number) {
    this.router.navigate(["/produtos-cadastro/" + id]);
  }

  /* Dados */

  carregarDados(inicial: boolean) {
    this.carregando = true;

    this.produtoService.getByGuidClienteNapis().subscribe(
      produtos => this.produtos = produtos,
      error => { console.log("Erro: " + error) },
      () => {
        this.produtosOriginal = JSON.parse(JSON.stringify(this.produtos));

        this.carregarOpcoesModeloCustos();

        /* Produto (Campanha) */

        this.produtoService.getProdutoCampanhaByGuidClienteNapis().subscribe(
          produtosCampanha => this.produtosCampanha = produtosCampanha,
          error => { console.log("Erro: " + error) },
          () => {
            this.filtrarProduto(inicial);

            this.carregando = false;
          }
        );
      }
    );
  }

  /* Filtro (Produtos) */

  alterarFiltroProduto(filtro_selecionado: number) {
    this.reiniciarDadosProduto();

    let filtroAtual: string = this.formFiltroProduto.controls["filtro"].value;

    this.formFiltroProduto.reset();

    if (filtro_selecionado == null) {
      this.formFiltroProduto.controls["filtro"].setValue(filtroAtual);
    } else {
      this.formFiltroProduto.controls["filtro"].setValue(filtro_selecionado);
    }

    this.organizarFiltroProduto();

    this.enviadoProduto = false;
    this.filtrandoProduto = false;
  }

  filtrarProduto(inicial: boolean) {
    if (!inicial) {
      this.enviadoProduto = true;

      if (this.formFiltroProduto.invalid) {
        return;
      }

      this.reiniciarDadosProduto();

      if (this.formFiltroProduto.controls["filtro"].value == "0") {
        /* Código */

        if (this.formFiltroProduto.controls["codigo"].value != "" && this.formFiltroProduto.controls["codigo"].value != null) {
          this.produtos = this.produtos.filter(produto => {
            if (produto.codigo == null) {
              return false;
            } else {
              return (produto.codigo.toLowerCase().indexOf(this.formFiltroProduto.controls["codigo"].value.trim().toLowerCase()) !== -1);
            }
          });
        }
      } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
        /* Descrição */

        if (this.formFiltroProduto.controls["descricao"].value != "" && this.formFiltroProduto.controls["descricao"].value != null) {
          this.produtos = this.produtos.filter(produto => {
            if (produto.name == null) {
              return false;
            } else {
              return (produto.name.toLowerCase().indexOf(this.formFiltroProduto.controls["descricao"].value.trim().toLowerCase()) !== -1);
            }
          });
        }
      } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
        /* Marca */

        if (this.formFiltroProduto.controls["marca"].value != "" && this.formFiltroProduto.controls["marca"].value != null) {
          this.produtos = this.produtos.filter(produto => {
            if (produto.grupo_estoque == null) {
              return false;
            } else {
              return (produto.grupo_estoque.toLowerCase().indexOf(this.formFiltroProduto.controls["marca"].value.trim().toLowerCase()) !== -1);
            }
          });
        }
      }

      this.filtrandoProduto = true;
    }

    this.atualizarPaginaProdutos();
  }

  organizarFiltroProduto() {
    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Código */

      this.formFiltroProduto.get("codigo").enable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Descrição */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").enable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Marca */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").enable();
    }
  }

  reiniciarDadosProduto() {
    this.produtos = JSON.parse(JSON.stringify(this.produtosOriginal));
    this.produtosPage = 1;
    this.atualizarPaginaProdutos();
  }

  get podeExportarProdutos(): boolean {
    return this.is_master || this.is_diretor;
  }

  get podeAtualizarProdutoTr(): boolean {
    return this.is_master || this.is_diretor || this.is_financeiro;
  }

  exportarProdutosFiltrados() {
    const produtosExportacao = (this.produtos || [])
      .filter(produto => produto && produto.is_active === true)
      .map(produto => ({
        id: produto.id,
        name: produto.name,
        price: produto.price,
        custo: produto.custo,
        estoque: produto.estoque,
        id_no_erp_do_cliente: produto.id_no_erp_do_cliente,
        grupo_estoque: produto.grupo_estoque,
        subgrupo_estoque: produto.subgrupo_estoque,
        subgrupo_estoque2: produto.subgrupo_estoque2,
        subgrupo_estoque3: produto.subgrupo_estoque3,
        subgrupo_estoque4: produto.subgrupo_estoque4,
        desc_maximo: produto.desc_maximo,
        valor_litragem: produto.valor_litragem,
        pontuacao: produto.pontuacao,
        margem: produto.margem
      }));

    if (produtosExportacao.length === 0) {
      this.toastr.warning('', 'Nenhum produto ativo para exportar.');
      return;
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(produtosExportacao);
    XLSX.utils.book_append_sheet(wb, ws, 'Produtos');
    XLSX.writeFile(wb, `produtos_${this.obterDataHoraArquivo()}.xlsx`);
  }

  private obterDataHoraArquivo(): string {
    const agora = new Date();
    const pad = (valor: number) => valor.toString().padStart(2, '0');
    return `${agora.getFullYear()}${pad(agora.getMonth() + 1)}${pad(agora.getDate())}_${pad(agora.getHours())}${pad(agora.getMinutes())}`;
  }

  /* Portal Compras */

  definirPromocao(id: number, definir: boolean) {
    let alterarPromocao: boolean = false;

    this.produtoService.updatePromocaoById(id, definir).subscribe(
      alterarPromocoes => alterarPromocao = alterarPromocoes,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarPromocao) {
          this.carregarDados(!this.enviadoProduto);

          if (definir) {
            this.toastr.success("", "Produto definido como promoção!");
          } else {
            this.toastr.success("", "Produto removido como promoção!");
          }
        }
      }
    );
  }

  exibirAtualizarProdutoTr(produto: Produto): boolean {
    return this.podeAtualizarProdutoTr
      && this.configuracao != null
      && (this.configuracao.integracao_erp_tipo || "").toUpperCase() == "SAPSERVICELAYER"
      && produto != null
      && produto.id_no_erp_do_cliente != null
      && produto.id_no_erp_do_cliente != "";
  }

  atualizarProdutoTr(produto: Produto) {
    if (!this.exibirAtualizarProdutoTr(produto) || this.atualizandoProdutoTrId != 0) {
      return;
    }

    this.atualizandoProdutoTrId = produto.id;

    this.produtoService.atualizarProdutoSapServiceLayer(produto.id).subscribe(
      resultado => {
        if (resultado != null && resultado.sucesso) {
          this.toastr.success("", resultado.mensagem || "Produto TR atualizado com sucesso.");
          this.carregarDados(!this.enviadoProduto);
        }
      },
      error => {
        console.log("Erro: " + error);
        this.atualizandoProdutoTrId = 0;
      },
      () => {
        this.atualizandoProdutoTrId = 0;
      }
    );
  }

  liberarPortalCompras(id: number, liberar: boolean) {
    let alterarExibicao: boolean = false;

    this.produtoService.updateMostrarB2BById(id, liberar).subscribe(
      alterarExibicoes => alterarExibicao = alterarExibicoes,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarExibicao) {
          this.carregarDados(!this.enviadoProduto);

          if (liberar) {
            this.toastr.success("", "Produto liberado!");
          } else {
            this.toastr.success("", "Produto bloqueado!");
          }
        }
      }
    );
  }

  /* Produto (Campanha) */

  alterarProdutoCampanha(id_campanha: number) {
    this.router.navigate(["/produtos-campanhas-cadastro/" + id_campanha]);
  }

  expandirProdutoCampanha(i: number, id_campanha: number) {
    this.produtoCampanhaExpandido = i == this.produtoCampanhaExpandido ? -1 : i;

    if (this.produtoCampanhaExpandido > -1) {
      this.produtoService.getProdutoCampanhaItensByIdCampanha(id_campanha).subscribe(
        produtosCampanhaItens => this.produtosCampanhaItens = produtosCampanhaItens,
        error => { console.log("Erro: " + error) },
        () => {

        }
      );
    }
  }

  campMudarPagina(pagina: number) {
    this.campPage = pagina;
    this.produtoCampanhaExpandido = -1;
  }

  campMudarPageSize(size: number) {
    this.campPageSize = size;
    this.campPage = 1;
    this.produtoCampanhaExpandido = -1;
  }

  novoProdutoCampanha() {
    this.router.navigate(["/produtos-campanhas-cadastro"]);
  }

  /* Produto (Tabela Especial) */

  alterarProdutoTabelaEspecial(id_produto_tabela_especial: number) {
    this.router.navigate(["/produtos-promocoes-cadastro/" + id_produto_tabela_especial]);
  }

  expandirProdutoTabelaEspecial(i: number, id_produto_tabela_especial: number) {
    this.produtoTabelaEspecialExpandido = i == this.produtoTabelaEspecialExpandido ? -1 : i;

    if (this.produtoTabelaEspecialExpandido > -1) {
      this.produtoService.getProdutoTabelaEspecialItensByIdProdutoTabelaEspecial(id_produto_tabela_especial).subscribe(
        produtosTabelaEspecialItens => this.produtosTabelaEspecialItens = produtosTabelaEspecialItens,
        error => { console.log("Erro: " + error) },
        () => {

        }
      );
    }
  }

  novoProdutoTabelaEspecial() {
    this.router.navigate(["/produtos-promocoes-cadastro"], { queryParams: { tabelaEspecial: 'false' } });
  }

  novaTabelaEspecial() {
    this.router.navigate(["/produtos-promocoes-cadastro"], { queryParams: { tabelaEspecial: 'true' } });
  }

  /* Custo */

  custoOnArquivoSelecionado(event: any) {
    this.custoErroUpload = null;
    this.custoLinhas = [];
    this.custoResultado = null;

    const file: File = event.target.files[0];
    if (!file) return;

    this.custoArquivo = file;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

        if (rows.length < 2) {
          this.custoErroUpload = 'Planilha vazia ou sem dados.';
          return;
        }

        const headers = rows[0].map((h: any) => String(h).trim().toUpperCase());
        const idxCodprod = headers.indexOf('CODPROD');
        const idxCusto = headers.indexOf('CUSTO');
        const idxMargem = headers.indexOf('MARGEM');

        if (idxCodprod === -1 || idxCusto === -1 || idxMargem === -1) {
          this.custoErroUpload = 'Colunas obrigatórias não encontradas. Esperado: CODPROD, CUSTO, MARGEM';
          return;
        }

        const itens: CustoItemDto[] = [];
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];
          const codprod = String(row[idxCodprod] || '').trim();
          if (!codprod) continue;

          const custo = parseFloat(String(row[idxCusto] || '').replace(',', '.'));
          const margem = parseFloat(String(row[idxMargem] || '').replace(',', '.'));

          if (isNaN(custo) || isNaN(margem)) continue;

          itens.push({ codprod, custo, margem });
        }

        if (itens.length === 0) {
          this.custoErroUpload = 'Nenhuma linha válida encontrada na planilha.';
          return;
        }

        if (itens.length > 1000) {
          this.custoErroUpload = `Planilha contém ${itens.length} linhas. Máximo permitido: 1.000.`;
          return;
        }

        this.custoLinhas = itens;
      } catch (err) {
        this.custoErroUpload = 'Erro ao ler o arquivo. Verifique se é um .xlsx válido.';
      }
    };
    reader.readAsBinaryString(file);
  }

  custoBaixarModelo() {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([
      ['CODPROD', 'CUSTO', 'MARGEM'],
      ['111', 100.00, 40],
      ['222', 50.50, 35]
    ]);
    XLSX.utils.book_append_sheet(wb, ws, 'Custos');
    XLSX.writeFile(wb, 'modelo_custos.xlsx');
  }

  custoEnviar() {
    if (this.custoLinhas.length === 0 || this.custoEnviando) return;

    this.custoEnviando = true;
    this.custoResultado = null;

    const atualizarPromocoes = this.custoAtualizarPromocoes ? 'S' : 'N';

    this.produtoService.atualizarCustosExcel(atualizarPromocoes, this.custoLinhas).subscribe(
      resultado => {
        this.custoResultado = resultado;
        this.custoEnviando = false;
        this.toastr.success('', `Concluído: ${resultado.total_atualizados} atualizado(s), ${resultado.total_erros} erro(s).`);
      },
      () => {
        this.custoEnviando = false;
      }
    );
  }

  custoNovaImportacao() {
    this.custoArquivo = null;
    this.custoLinhas = [];
    this.custoResultado = null;
    this.custoErroUpload = null;
    this.custoFiltroStatus = '';
  }

  /* Modelo Custos */

  carregarOpcoesModeloCustos() {
    this.modeloCustosAtualizarValoresDisponiveis();
  }

  modeloCustosAtualizarValoresDisponiveis() {
    const campo = this.modeloCustosFiltroSelecionado;
    const jaAplicados = this.modeloCustosFiltrosAplicados
      .filter(f => f.campo === campo)
      .map(f => f.valor);

    this.modeloCustosValoresDisponiveis = [...new Set(
      this.produtosOriginal
        .map(p => p[campo])
        .filter(v => v != null && v.toString().trim() !== '' && !jaAplicados.includes(v))
    )].sort();

    this.modeloCustosValorSelecionado = '';
  }

  modeloCustosAdicionarFiltro() {
    if (!this.modeloCustosValorSelecionado) return;

    const tipo = this.modeloCustosTiposFiltro.find(t => t.campo === this.modeloCustosFiltroSelecionado);
    const jaExiste = this.modeloCustosFiltrosAplicados.some(
      f => f.campo === this.modeloCustosFiltroSelecionado && f.valor === this.modeloCustosValorSelecionado
    );

    if (!jaExiste) {
      this.modeloCustosFiltrosAplicados.push({
        campo: this.modeloCustosFiltroSelecionado,
        label: tipo ? tipo.label : this.modeloCustosFiltroSelecionado,
        valor: this.modeloCustosValorSelecionado
      });
    }

    this.modeloCustosAtualizarValoresDisponiveis();
  }

  modeloCustosRemoverFiltro(index: number) {
    this.modeloCustosFiltrosAplicados.splice(index, 1);
    this.modeloCustosAtualizarValoresDisponiveis();
  }

  modeloCustosLimparFiltros() {
    this.modeloCustosFiltrosAplicados = [];
    this.modeloCustosDescricao = '';
    this.modeloCustosAtualizarValoresDisponiveis();
  }

  modeloCustosGerarExcel() {
    let filtrados = this.produtosOriginal.filter(p => p.is_active);

    if (this.modeloCustosDescricao.trim()) {
      const termo = this.modeloCustosDescricao.toLowerCase().trim();
      filtrados = filtrados.filter(p =>
        (p.name && p.name.toLowerCase().includes(termo)) ||
        (p.codigo && p.codigo.toLowerCase().includes(termo))
      );
    }

    const filtrosPorCampo: { [campo: string]: string[] } = {};
    this.modeloCustosFiltrosAplicados.forEach(f => {
      if (!filtrosPorCampo[f.campo]) filtrosPorCampo[f.campo] = [];
      filtrosPorCampo[f.campo].push(f.valor);
    });

    for (const campo of Object.keys(filtrosPorCampo)) {
      const valores = filtrosPorCampo[campo];
      filtrados = filtrados.filter(p => valores.includes(p[campo]));
    }

    if (filtrados.length === 0) {
      this.toastr.warning('', 'Nenhum produto encontrado com os filtros aplicados.');
      return;
    }

    let truncado = false;
    if (filtrados.length > 10000) {
      filtrados = filtrados.slice(0, 10000);
      truncado = true;
    }

    this.produtoService.getProdutoLocalByGuidClienteNapis().subscribe(locais => {
      const formatarDecimal = (v: any): string => {
        if (v == null || v === '') return '';
        const n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
        return isNaN(n) ? String(v) : n.toFixed(2).replace('.', ',');
      };

      const locaisOrdenados = [...new Set(locais.map(l => l.local))].sort();

      const estoqueMap = new Map<number, Map<string, number>>();
      locais.forEach(l => {
        if (!estoqueMap.has(l.idproduto)) estoqueMap.set(l.idproduto, new Map());
        estoqueMap.get(l.idproduto).set(l.local, Number(l.estoque));
      });

      const cabecalho = ['CODPROD', 'DESCRICAO', 'PRECO_TABELA','CUSTO', 'MARGEM',  'ESTOQUE', ...locaisOrdenados];
      const dados = [cabecalho];

      filtrados.forEach(p => {
        const estoquesPorLocal = estoqueMap.get(p.id) || new Map();
        const colunaLocais = locaisOrdenados.map(local => { const v = estoquesPorLocal.get(local); return formatarDecimal(v !== undefined ? v : 0); });
        dados.push([
          p.codigo || '',
          p.name || '',
          formatarDecimal(p.price),
          formatarDecimal(p.custo),
          formatarDecimal(p.margem),
          formatarDecimal(p.estoque),
          ...colunaLocais
        ]);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(dados);
      const colsFixas = [{ wch: 15 }, { wch: 50 }, { wch: 14 }, { wch: 12 }, { wch: 12 }, { wch: 12 }];
      const colsLocais = locaisOrdenados.map(() => ({ wch: 14 }));
      ws['!cols'] = [...colsFixas, ...colsLocais];
      XLSX.utils.book_append_sheet(wb, ws, 'Modelo Custos');

      const agora = new Date();
      const sufixo = agora.getFullYear().toString() +
        (agora.getMonth() + 1).toString().padStart(2, '0') +
        agora.getDate().toString().padStart(2, '0') + '_' +
        agora.getHours().toString().padStart(2, '0') +
        agora.getMinutes().toString().padStart(2, '0');

      XLSX.writeFile(wb, `modelo_custos_${sufixo}.xlsx`);

      if (truncado) {
        this.toastr.warning('', 'Limitado a 10.000 produtos. Refine os filtros para obter resultados mais precisos.');
      } else {
        this.toastr.success('', `Excel gerado com ${filtrados.length} produto(s).`);
      }
    });
  }

  /* Promoções (busca paginada) */

  get promoTemFiltro(): boolean {
    return (this.promoFiltros.descricao && this.promoFiltros.descricao.trim().length > 0)
      || this.promoFiltros.ativo !== null;
  }

  get promoTotalPaginas(): number {
    return Math.ceil(this.promoTotal / this.promoPageSize);
  }

  promoBuscar() {
    this.promoPage = 1;
    this.promoBusca$.next();
  }

  promoLimpar() {
    const te = this.promoFiltros.tabelaEspecial;
    this.promoFiltros = { descricao: '', ativo: null, tabelaEspecial: te };
    this.promoPage = 1;
    this.promoBusca$.next();
  }

  promoMudarPagina(pagina: number) {
    this.promoPage = pagina;
    this.promoBusca$.next();
  }

  promoMudarPageSize(size: number) {
    this.promoPageSize = size;
    this.promoPage = 1;
    this.promoBusca$.next();
  }
}
